import React, {Component} from 'react'
import '../../../styles/Admin.css'
import {Button} from "react-bootstrap";
import {Editor} from 'react-draft-wysiwyg'
import {convertToRaw, EditorState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Modal from 'react-modal'
import AdminGaleria from "../AdminGaleria";
import AdminService from "../AdminService";
import {NotificationManager} from "react-notifications";


export default class AdminAktualnosci extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tytul: '',
            tresc: EditorState.createEmpty(),
            opis: '',
            modalIsOpen: false,
            zdjecie: [],
            zdjecieShow: [],
            opublikowano: false,
        };

        this.handleTytulChange = this.handleTytulChange.bind(this);
        this.handleTrescChange = this.handleTrescChange.bind(this);
        this.handleOpisChange = this.handleOpisChange.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            tresc: editorState,
        });
    };

    handleTytulChange(e) {
        this.setState({tytul: e.target.value})
    }

    handleTrescChange(e) {
        this.setState({tresc: e.target.value})
    }

    handleOpisChange(e) {
        this.setState({opis: e.target.value})
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({zdjecieInvalid: true, zdjecie: ''});
            NotificationManager.error("", "Niepoprawny plik zdjęcia ", 5000)
        } else {
            this.setState({zdjecieInvalid: false, zdjecie: accepted})
        }
    }

    convertToBase(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            return reader.result
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState(prevState => ({
                zdjecieShow: [...prevState.zdjecieShow, {
                    dane: reader.result.split(",")[1],
                    nazwa: file[0].name,
                    dokumentTyp: "STRONA_WPIS",
                    typ: file[0].type,
                    rozmiar: file[0].size,
                }]
            }));
            this.setState({zdjecie: '', opis: ''})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    deleteImage(image) {
        let images = this.state.zdjecieShow;
        images = images.filter(el => el !== image);
        this.setState({zdjecieShow: images})
    }

    uploadNews() {
        console.log(this.state.zdjecieShow)
        AdminService.postStrona("NEWS", this.state.tytul, draftToHtml(convertToRaw(this.state.tresc.getCurrentContent())), this.state.opublikowano, null, this.state.zdjecieShow)
            .then(function (response) {
                this.props.goZarzadzanie()
            }.bind(this));
        this.props.goZarzadzanie()
    }

    render() {
        return <div className="aktualnosciTabContainer">

            <Modal
                isOpen={this.state.modalIsOpen}
                onRequestClose={this.closeModal}
                contentLabel="Biblioteka mediów"
                style={{
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                }}
            >
                <AdminGaleria modal={true} container={true} closeModal={() => this.closeModal()}
                              wybierzObraz={(obraz) => {
                                  this.getBase64(obraz);
                                  this.closeModal()
                              }}/>
            </Modal>
            <div className="aktualnosciOpis">
                Aby dodać nowy wpis należy uzupełnić wszystkie pola, oraz dodać zdjęcia. Wpis można później edytować
                przez zakładkę
                <span style={{cursor: 'pointer'}} onClick={() => this.props.goZarzadzanie()}>
                    <b> zarządzanie</b>
                </span>.
            </div>
            <div className="nowyWpisForm">
                <div className="field">Tytuł:
                    <input type="text" value={this.state.tytul} maxLength={100} onChange={this.handleTytulChange}
                           className="form-control"/></div>
                <div className="field">Treść:
                    <Editor
                        editorState={this.state.tresc}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperEditor"
                        editorClassName="editorEditor"
                        onEditorStateChange={this.onEditorStateChange}
                    /></div>
                <div className="field">
                    <div className="row">
                        <div className="col-sm-6">
                            Dodaj zdjęcia:
                            <div onClick={this.state.zdjecieShow.length < 9 ? () => this.openModal() : null}
                                 style={{
                                     marginTop: 15,
                                     height: 150,
                                     width: '95%',
                                     padding: 60,
                                     textAlign: 'center',
                                     border: '1px dashed #ced4da',
                                     borderRadius: '.25rem',
                                     cursor: 'pointer'
                                 }}>
                                {this.state.zdjecieShow.length < 9 ?
                                    <div style={{color: '#007bff'}}>Kliknij by otworzyć bibliotekę
                                        mediów</div> : 'Osiągnięto maksymalną ilość obrazków dla wpisu (9)'}</div>
                        </div>
                        <div className="col-sm-6" style={{borderLeft: '1px solid #eaeaea'}}>
                            Dodane zdjęcia:
                            <div className={'row text-right'}>
                                {this.state.zdjecieShow.length === 0 ?
                                    <div style={{
                                        marginTop: 15,
                                        marginLeft: 15,
                                        height: 150,
                                        width: '95%',
                                        padding: 60,
                                        textAlign: 'center',
                                        border: '1px dashed #ced4da',
                                        borderRadius: '.25rem'
                                    }}>
                                        Brak zdjęć</div>
                                    : <div className="row" style={{marginLeft: 25, marginRight: 25}}>
                                        {this.state.zdjecieShow.map((item, i) => {
                                            return <div className='col-4 text-center imageBorderNowyWpis'
                                                        style={{paddingTop: 25, paddingBottom: 15}}>
                                                <i className="fa fa-times"
                                                   style={{
                                                       color: 'red',
                                                       float: 'right',
                                                       paddingTop: 10,
                                                       cursor: 'pointer'
                                                   }}
                                                   onClick={() => this.deleteImage(item)}> </i>
                                                <img
                                                    src={'data:' + this.state.zdjecieShow[0].typ + ';base64, ' + this.state.zdjecieShow[0].dane}
                                                    width={'60%'}/>
                                                <div style={{fontSize: '0.75rem', paddingTop: 5}}>{item.opis}</div>
                                            </div>
                                        })}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <div className="text-right">
                    <span style={{width: 105, textAlign: 'center'}}>Opublikować post po dodaniu:
                        <input type={'checkbox'} style={{marginLeft: 5, marginRight: 10, paddingTop: 3}}
                               checked={this.state.opublikowano}
                               onChange={() => this.setState({opublikowano: !this.state.opublikowano})}/>
                    </span>
                    <Button bsStyle={'success'} onClick={() => this.uploadNews()}>Dodaj wpis</Button>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/aktualnosciComponents/NowyWpis.js